var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageComponent } from '@synisys/idm-de-service-client-js';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { RoutingHistoryService } from '../../service/local';
var NoPermissionPageComponent = /** @class */ (function (_super) {
    __extends(NoPermissionPageComponent, _super);
    function NoPermissionPageComponent(_router, _route, _routingHistoryService) {
        var _this = _super.call(this) || this;
        _this._router = _router;
        _this._route = _route;
        _this._routingHistoryService = _routingHistoryService;
        _this.DYNAMIC_DE_PREFIX = '/dynamic-de/';
        _this.destroySubject$ = new Subject();
        return _this;
    }
    Object.defineProperty(NoPermissionPageComponent.prototype, "warningMessage", {
        get: function () {
            return this._warningMessage;
        },
        enumerable: true,
        configurable: true
    });
    NoPermissionPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._route.params
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(function (params) {
            var categoryPermissionName = params['categoryPermissionName'];
            _this.initPermissionMessage(categoryPermissionName);
        }, console.error);
    };
    NoPermissionPageComponent.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    NoPermissionPageComponent.prototype.onOkClicked = function () {
        var _this = this;
        var historyReversed = this._routingHistoryService
            .getHistory()
            .slice()
            .reverse();
        var lastPageIndex = historyReversed.findIndex(function (url) { return url.indexOf(_this.DYNAMIC_DE_PREFIX) !== -1; });
        if (lastPageIndex === -1) {
            window.history.back();
            return;
        }
        do {
            lastPageIndex++;
        } while (lastPageIndex < historyReversed.length &&
            historyReversed[lastPageIndex].indexOf(this.DYNAMIC_DE_PREFIX) !==
                -1);
        if (lastPageIndex > historyReversed.length - 1) {
            window.history.back();
            return;
        }
        // noinspection JSIgnoredPromiseFromCall
        this._router.navigateByUrl(historyReversed[lastPageIndex]);
    };
    NoPermissionPageComponent.prototype.initPermissionMessage = function (categoryPermissionName) {
        switch (categoryPermissionName) {
            case 'view':
                this._warningMessage = 'de_no_view_permission';
                break;
            case 'edit':
                this._warningMessage = 'de_no_edit_permission';
                break;
            case 'add':
            case 'search':
                this._warningMessage = 'de_no_add_permission';
                break;
            case 'delete':
                this._warningMessage = 'de_no_delete_permission';
                break;
            default:
                throw new TypeError(categoryPermissionName + ": not supported permission type");
        }
    };
    NoPermissionPageComponent = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'sis-permission',
            template: require('./no-permission-page.component.html'),
        }),
        __metadata("design:paramtypes", [Router,
            ActivatedRoute,
            RoutingHistoryService])
    ], NoPermissionPageComponent);
    return NoPermissionPageComponent;
}(PageComponent));
export { NoPermissionPageComponent };
//# sourceMappingURL=no-permission-page.component.js.map